import {Fragment, useEffect, useState} from 'react';
import {compose} from 'redux';
import {connect} from 'react-redux';
import {Link, withRouter} from 'react-router-dom';
import queryString from 'query-string';
import {Button} from 'semantic-ui-react';
import Loader from '../shared/loader';
import {verifyPayment} from '../../redux/actions/payment';
import {fetchStudentData} from '../../redux/actions/student';

function PaymentVerify(props) {
  const {Status: status, Authority: authority} = queryString.parse(props.location.search);
  const {verifyPayment, fetchStudentData, match: {params: {paymentId}}} = props;
  const [response, setResponse] = useState({});
  const [error, setError] = useState(null);

  useEffect(() => {
    (async function () {
      try {
        const {payload} = await verifyPayment(paymentId, authority, status);
        setResponse(payload);
        fetchStudentData();
      } catch (error) {
        setError(error);
      }
    })();
  }, [paymentId, status, authority, verifyPayment, fetchStudentData]);

  if (error) return (
    <Fragment>
      <p>پرداخت مورد نظر یافت نشد!</p>
      <Link to='/consult-packages'>بازگشت</Link>
    </Fragment>
  );

  if (!response.code) return (<Loader/>);

  return (
    <Fragment>
      {([100, 101].includes(response.code)) ? (
        <Fragment>
          {(response.code === 100) ? (
            <Fragment>
              <p>{'شماره تراکنش خرید: ' + response.refId}</p>
              <p>بسته موردنظر شما با موفقیت خریداری گردید.</p>
            </Fragment>
          ) : (
            <p>تراکنش با موفقیت انجام شده است.</p>
          )}
        </Fragment>
      ) : (
        <p>متاسفانه تراکنش ناموفق بود.</p>
      )}
      <Button positive as={Link} to='/report' content='بازگشت'/>
    </Fragment>
  );
}

export default compose(
  withRouter,
  connect(null, {verifyPayment, fetchStudentData})
)(PaymentVerify);
